import PropTypes from 'prop-types'
import { Trans, useTranslation } from 'react-i18next'
import InfoModal from '../../../common/InfoModal'

import { ReactComponent as WarningIcon } from '../../../../assets/images/common/icons/warning-icon.svg'
import colors from '../../../../assets/styles/globals.scss'

const DefaultBodyText = () => {
  const { t } = useTranslation()

  return (
    <>
      <p>
        {t('communitySettings.pricing.archiveModal.defaultCannotDelete')}
      </p>
      <p>
        {t('communitySettings.pricing.archiveModal.defaultArchiveRemoves')}
      </p>
      <p>
        {t('communitySettings.pricing.archiveModal.defaultViewDetails')}
      </p>
      <p style={{ color: colors.red }}>
        <strong>{t('communitySettings.common.actionPermanent')}</strong>
      </p>
    </>
  )
}

const SingleWithinProgramBodyText = () => {
  const { t } = useTranslation()

  return (
    <>
      <p>
        <Trans i18nKey='communitySettings.pricing.archiveModal.singleIntro' components={{ b: <b/> }} />
      </p>
      <p>
        <b>{t('communitySettings.pricing.archiveModal.ifArchive')}</b>
        <ul>
          <li>{t('communitySettings.pricing.switchToOfflinePayments')}</li>
          <li>{t('communitySettings.pricing.onlinePaymentsDisabledUntilNew')}</li>
        </ul>
      </p>
      <p>{t('communitySettings.pricing.programsNeedActivePackage')}</p>
      <p>{t('communitySettings.pricing.archiveModal.afterArchiveViewDetails')}</p>
      <p style={{ color: colors.red }}>
        <strong>{t('communitySettings.common.actionPermanent')}</strong>
      </p>
    </>
  )
}

const ArchivePackageConfirmationModal = ({ isSingleWithinProgram, ...props }) => {
  const { t } = useTranslation()

  return (
    <InfoModal
      title={t('communitySettings.pricing.archiveModal.title')}
      icon={<WarningIcon />}
      buttonMessage={t('common.action.archive')}
      {...props}
    >
      <div className='mx-4 text-left'>
        {isSingleWithinProgram ? <SingleWithinProgramBodyText /> : <DefaultBodyText />}
      </div>
    </InfoModal>
  )
}

ArchivePackageConfirmationModal.propTypes = {
  isSingleWithinProgram: PropTypes.bool,
}

export default ArchivePackageConfirmationModal
